<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "VoiceAgentPhoneNumberInboundAgentChanged",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            return this.$t('notification.voiceAgentPhoneNumberInboundAgentChanged', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                phoneNumber: this.$_.get(this.activity, 'payload.phoneNumber'),
                agentName: this.$_.get(this.activity, 'payload.agentName')
            });
        }
    }
};
</script>

